module.exports = __webpack_public_path__ + "img/laser-turret-gun-shadow.1c1433b6.png";